module.exports = __webpack_public_path__ + "fonts/AlloyInk-lgdWw-2.fee4c5e9.otf";